import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { sanitize } from 'dompurify';
import { get } from 'lodash';
import { getCMSUrlToPromotions } from '../../constants/cms-urls';

const mapStateToProps = (state) => ({
  menuPromotions: state.MenuPromotions.menuPromotions,
  storefront : state.Manage.storefront,
  travelInformation: state.TravelInformation.travelInformation,
});
class HeaderMenuPromotions extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      kindPromotions:'',
      
    };
  }
  
  render() {
    const { 
      className, 
      menuBookStyle, 
      menuOptions,
      storefront,
    } = this.props;
    
    const mainInfo = menuOptions.main || {};
    const centerColumnOne = get(menuOptions, 'center.columnOne', []);

    const centerColumnTwo = get(menuOptions, 'center.columnTwo', []);
    const titleColumn1 = get(menuOptions, 'center.columnOneTitle', '');
    const titleColumn2 = get(menuOptions, 'center.columnTwoTitle', '');

    const bookClasses = cx(
      {
        'HeaderMenuPromotions': true,
      },
      className
    );
    
    if (Object.keys(mainInfo).length === 0 ) return null;
    const urlTrial = (mainInfo.mainLinkUrl).includes('https');
    
    return (
      <div className={ bookClasses } style={ menuBookStyle }>
        <div className='HeaderMenuPromotions-mainWrapper'>
          <div className='HeaderMenuPromotions-mainInfo'>
            <a
              className='HeaderMenuPromotions-mainInfo-link'
              onClick={ () => this.trackMenuClick({  i: 'fligths', value: mainInfo.mainLinkUrl }) }
              href={ urlTrial ? mainInfo.mainLinkUrl : getCMSUrlToPromotions(storefront, mainInfo.mainLinkUrl)}
              link={ mainInfo.mainLinkUrl || '' }
            >
              
              <section className='HeaderMenuPromotions-mainInfo-wrapper'>
                <div className={`HeaderMenuPromotions-mainInfo-image-wrapper HeaderMenuPromotions-mainInfo-image-wrapper--${ mainInfo.mainLinkColor || '' }` }>
                  <img src={ mainInfo && mainInfo.mainImage && mainInfo.mainImage.mainImageUrl }
                    alt={ mainInfo.mainLinkTitle || '' }
                    className='HeaderMenuPromotions-mainInfo-image'/>
                </div>
                <div className='HeaderMenuPromotions-mainInfo-content'>
                  <h3 className='HeaderMenuPromotions-mainInfo-title'>{ mainInfo.mainLinkTitle || '' }</h3>
                  <div className='HeaderMenuPromotions-mainInfo-description' dangerouslySetInnerHTML={{ __html: sanitize(mainInfo.mainLinkDescription) }}></div>
                  <p className='HeaderMenuPromotions-mainInfo-cta Link'>{ mainInfo.mainLinkCta || '' } <span className='Icon Icon--arrowRightBold'></span></p>
                </div>
              </section>
            </a>
          </div>
          <div className='HeaderMenuPromotions-Links'>
            <div className='HeaderMenuPromotions-Links-col'>
              <div className='HeaderMenuPromotions-Links-mainlink'>{ titleColumn1 }</div>
              <ul className='HeaderMenuPromotions-itemList'>
                {
                  centerColumnOne.map((infoColumnOne, index) => {
                    if (infoColumnOne.centerLinkUrl) {
                      const urlPromotions = (infoColumnOne.centerLinkUrl).includes('https');
                      
                      return (
                        <li className='HeaderMenuPromotions-item' key={ `infoColumnOne_${ index }` }>
                          <a
                            className='HeaderMenuPromotions-link'
                            onClick={ () => this.trackMenuClick({ i: index, value: infoColumnOne.centerLinkUrl }) }
                            href={ urlPromotions ? infoColumnOne.centerLinkUrl : getCMSUrlToPromotions(storefront, infoColumnOne.centerLinkUrl)}
                          >
                            { infoColumnOne.centerLinkCta }
                          </a>
                        </li>
                      );
                    }
                  })
                }
              </ul>
            </div>
            <div className='HeaderMenuPromotions-Links-col'>
              <div className='HeaderMenuPromotions-Links-mainlink'>{ titleColumn2 }</div>
              <ul className='HeaderMenuPromotions-itemList'>
                {
                  centerColumnTwo.map((infoColumnTwo, index) => {
                    if (infoColumnTwo.centerLinkUrl) {
                      const urlPromotions = (infoColumnTwo.centerLinkUrl).includes('https');

                      return (
                        <li className='HeaderMenuPromotions-item' key={ `infoColumnTwo_${ index }` }>
                          <a
                            className='HeaderMenuPromotions-link'
                            onClick={ () => this.trackMenuClick({ i: index, value: infoColumnTwo.centerLinkUrl }) }
                            href={ urlPromotions ?  infoColumnTwo.centerLinkUrl : getCMSUrlToPromotions(storefront, infoColumnTwo.centerLinkUrl)}
                          >
                            { infoColumnTwo.centerLinkCta } 
                          </a>
                        </li>
                      );
                    }
                  }) 
                }
              </ul>
            </div>
          </div>

          { this.renderIconLinksList() }
        </div>
      </div>
    );
  }

  trackMenuClick = ( urlId ) => {
    const { value } = urlId;
    this.setState({
      kindPromotions: value,
    });
  };

  renderIconLinksList() {
    const { 
      menuOptions,
      storefront,
    } = this.props;

    const moreOptions = menuOptions.right || [];

    return (
      <ul className='HeaderMenuPromotions-IconLinksList'>
        {
          moreOptions.map((option, index) => {
            if (option.rightLinkUrl) {
              const urlOption = (option.rightLinkUrl).includes('https');

              return (
                <li className='HeaderMenuPromotions-IconLinksList-item' key={ `options_${ index }` }>
                  <a
                    className='HeaderMenuPromotions-IconLinksList-link'
                    onClick={ () => this.trackMenuClick({ i: index, value: option.rightLinkCta }) }
                    href={urlOption ? option.rightLinkUrl : getCMSUrlToPromotions(storefront, option.rightLinkUrl) }
                  >
                    <img src={ option.rightLinkImg && option.rightLinkImg.rightLinkUrl }
                      alt={ (get(option, 'rightLinkImg.rightLinkAlt', '').length > 0 ? get(option, 'rightLinkImg.rightLinkAlt', '') : option.rightLinkCta) } />
                    { option.rightLinkCta }
                  </a>
                </li>
              );
            }
          })
        }
      </ul>
    );
  }
}

export default connect(mapStateToProps)(HeaderMenuPromotions);
